import { render, staticRenderFns } from "./PageScheduledMassMessage.vue?vue&type=template&id=2d48abf3&"
import script from "./PageScheduledMassMessage.vue?vue&type=script&lang=ts&"
export * from "./PageScheduledMassMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports